module.exports = __webpack_public_path__ + "img/W7026-tran.4fc0dbf1.jpg";